import request from '@/utils/request'

let Electronic_waybillApi = {

  /*电子运单列表*/
  list(data) {
    return request._post('/shop/plus.electronic_waybill.Index/index', data);
},
/*添加电子运单*/
add(data) {
    return request._post('/shop/plus.electronic_waybill.Index/add', data);
},
/*修改电子运单*/
edit(data) {
    return request._post('/shop/plus.electronic_waybill.Index/edit', data);
},
/*删除电子运单*/
del(data) {
    return request._post('/shop/plus.electronic_waybill.Index/del', data);
},
/*电子运单详情*/
detail(data) {
  return request._post('/shop/plus.electronic_waybill.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.electronic_waybill.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.electronic_waybill.Setting/getSetting', data, errorback);
    },
}
export default Electronic_waybillApi;



// WEBPACK FOOTER //
// ./src/api/electronic_waybill.js